module.exports = __webpack_public_path__ + "static/img/wheel_3.f469273.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lotto/wheel_3.png
// module id = X6BG
// module chunks = 2